import Settings from "../components/settings/model/Settings";

import { BASE_URL } from './common';

export class SettingsService {
  private authHeader: string;
  private user: string;

  constructor(user: string, wsid: string, csrf: string) {
    this.user = user;
    this.authHeader = btoa(wsid + ':' + csrf);
  }

  public async getSettings() {
    const url = `${BASE_URL}/users/${this.user}/settings`;
    const response = await fetch(url, {
      headers: {
        'Accept': 'application/json',
        'Authorization': 'Basic ' + this.authHeader,
        'Content-Type': 'application/json',
      },
      method: 'GET',
    });

    return response;
  }

  public async save(field: string, value: string) {
    const url = `${BASE_URL}/users/${this.user}/settings`;
    const settings = {} as Settings;

    settings[field] = value;

    const response = await fetch(url, {
      body: JSON.stringify(settings),
      headers: {
        'Accept': 'application/json',
        'Authorization': 'Basic ' + this.authHeader,
        'Content-Type': 'application/json',
      },
      method: 'PATCH',
    });

    return response;
  }
}


// WEBPACK FOOTER //
// ./src/services/settings.ts